import { Grid2 } from "@mui/material";
import SettingsFormField from "../forms/SettingsFormField";
import { SettingsTagList } from "../forms/SettingsTagList";

interface CompanyBasicInfoCardProps {
  name: string;
  employeeCount: string;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEmployeeCountChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  nameError?: string;
  employeeCountError?: string;
  loading?: boolean;
  locations: string[];
  websites: string[]; // Now used instead of just kept for compatibility
  onAddLocation: (location: string) => void;
  onRemoveLocation: (location: string) => void;
  onAddWebsite: (website: string) => void; // Now used instead of just kept for compatibility
  onRemoveWebsite: (website: string) => void; // Now used instead of just kept for compatibility
  websitesError?: string; // Now used instead of just kept for compatibility
  locationsError?: string;
}

export const CompanyBasicInfoCard = ({
  name,
  employeeCount,
  onNameChange,
  onEmployeeCountChange,
  nameError,
  employeeCountError,
  loading = false,
  locations,
  websites,
  onAddLocation,
  onRemoveLocation,
  onAddWebsite,
  onRemoveWebsite,
  websitesError,
  locationsError
}: CompanyBasicInfoCardProps) => {
  return (
    <Grid2 container spacing={3} sx={{ width: '100%' }}>
      <Grid2 sx={{ xs: 12, width: '100%' }}>
        <SettingsFormField
          label="Firmenname"
          value={name}
          onChange={onNameChange}
          loading={loading}
          error={nameError}
        />
      </Grid2>

      <Grid2 sx={{ xs: 12, width: '100%' }}>
        <SettingsFormField
          label="Mitarbeiteranzahl"
          type="number"
          value={employeeCount}
          onChange={onEmployeeCountChange}
          loading={loading}
          error={employeeCountError}
        />
      </Grid2>

      <Grid2 sx={{ xs: 12, width: '100%' }}>
        <SettingsTagList
          label="Standorte"
          tags={locations}
          onAdd={onAddLocation}
          onRemove={onRemoveLocation}
          placeholder="Neuen Standort hinzufügen"
          loading={loading}
          error={locationsError}
        />
      </Grid2>

      <Grid2 sx={{ xs: 12, width: '100%' }}>
        <SettingsTagList
          label="Webseiten"
          tags={websites}
          onAdd={onAddWebsite}
          onRemove={onRemoveWebsite}
          placeholder="www.example.com"
          loading={loading}
          error={websitesError}
        />
      </Grid2>
    </Grid2>
  );
}; 